export const getTitle = (isSingleMethodAvailable: boolean): string => {
  return isSingleMethodAvailable ? 'Способ оплаты' : 'Выберите способ';
};
